import React from 'react';

export default function RequestDisbursement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Request Disbursement</h1>
      <p className="text-gray-500">Halaman Request Disbursement</p>
    </div>
  );
}
